<ion-avatar (click)="viewAction()">
  <img 
  [defaultImage]="assetLinksService.avatarLoading" 
  [lazyLoad]="shop.logo" 
  [errorImage]="assetLinksService.noImage"/>
</ion-avatar>